module.exports = __webpack_public_path__ + "static/img/name7.5baa05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name7.png
// module id = NfKF
// module chunks = 1